import './IntervalFilter.scss';

import { Box } from "@mui/material";

import { Filter } from "../../common-components/Dropdowns/Dropdowns";

const IntervalFilter = ({ onIntervalChange, reset }) => {
    const options = [
        {
            id: 'week',
            name: 'За неделю'
        },
        {
            id: 'month',
            name: 'За месяц'
        },
        {
            id: 'year',
            name: 'За год'
        },
        {
            id: 'range',
            name: 'Диапазон'
        }
    ]

    const handleOptionClick = (option) => {
        onIntervalChange(option.id);
    };

    return (
        <Box className={"interval_filter"}>
            <Filter options={options} propertyLabel={"Интервал"} onOptionClick={handleOptionClick} reset={reset}/>
        </Box>
    )
}

export default IntervalFilter;